/* DEC-0045. Enhance native inline forms, never replace their inputs or handlers. */
(() => {
  'use strict';
  const selector = '.our-reviewyyyy .jdgm-form:not(.jdgm-form-dynamic)';
  const observed = new WeakSet();
  const carousels = new WeakSet();
  const popupOrigins = new WeakSet();
  // Lucide Star and Upload paths, ISC license, matching the approved wireframe.
  const starPath = 'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z';
  function icon(className, paths) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', className);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    paths.forEach(d => {
      const path = document.createElementNS(svg.namespaceURI, 'path');
      path.setAttribute('d', d);
      svg.append(path);
    });
    return svg;
  }
  function enhance(form) {
    if (form.classList.contains('rawry-review-form')) return;
    const rating = form.querySelector('.jdgm-form__rating');
    const heading = form.querySelector('.jdgm-form__title');
    const score = rating?.querySelector('input[name="score"]');
    if (!heading || !score || rating.querySelectorAll('.jdgm-star').length !== 5) return;
    form.classList.add('rawry-review-form');
    form.querySelectorAll('[name="review_title"], [name="review_body"], [name="reviewer_name"], [name="reviewer_email"]').forEach(input => input.closest('.jdgm-form__fieldset').classList.add('rawry-review-field'));
    heading.textContent = 'How would you rate it?';
    rating.closest('.jdgm-form__fieldset').classList.add('rawry-review-rating');
    rating.querySelectorAll('.jdgm-star').forEach(star => star.append(icon('rawry-review-star', [starPath])));
    const status = document.createElement('p');
    status.className = 'rawry-review-rating-status';
    status.setAttribute('role', 'status');
    rating.after(status);
    const updateRating = () => {
      const value = Number(score.value);
      const text = value >= 1 && value <= 5 ? `${value} out of 5` : 'Select a rating';
      if (status.textContent !== text) status.textContent = text;
      const error = rating.querySelector('div.jdgm-input-error');
      status.hidden = Boolean(error && getComputedStyle(error).display !== 'none');
    };
    rating.addEventListener('click', () => queueMicrotask(updateRating));
    rating.addEventListener('keydown', () => queueMicrotask(updateRating));
    score.addEventListener('change', updateRating);
    form.addEventListener('reset', () => requestAnimationFrame(updateRating));
    new MutationObserver(updateRating).observe(rating, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-checked', 'value', 'style'] });
    updateRating();

    form.querySelector('[name="yt_url"]')?.closest('.jdgm-form__fieldset').classList.add('rawry-review-youtube');
    form.querySelector('[name="reviewer_name"]')?.closest('.jdgm-form__fieldset').classList.add('rawry-review-name');
    const cancel = form.querySelector('.jdgm-cancel-rev');
    if (cancel) cancel.textContent = 'Cancel';
    const media = form.querySelector('.jdgm-media-fieldset__input');
    const wrapper = media?.parentElement.querySelector('.jdgm-picture-fieldset__box-wrapper');
    if (media && wrapper) {
      media.closest('.jdgm-form__fieldset').classList.add('rawry-review-media');
      media.setAttribute('aria-label', 'Photos (optional). Drop or choose files');
      const copy = document.createElement('span');
      copy.className = 'rawry-review-upload-copy';
      const label = document.createElement('strong');
      label.textContent = 'Photos (optional)';
      const hint = document.createElement('small');
      hint.append('Drop or ');
      const choose = document.createElement('u');
      choose.textContent = 'choose files';
      hint.append(choose);
      copy.append(label, hint);
      wrapper.append(icon('rawry-review-upload-icon', ['M12 3v12', 'm17 8-5-5-5 5', 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4']), copy);
      const box = media.closest('.jdgm-picture-fieldset__box--input');
      box.addEventListener('dragover', event => {
        if (!event.dataTransfer.types.includes('Files')) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
      });
      box.addEventListener('drop', event => {
        if (!event.dataTransfer.files.length) return;
        event.preventDefault();
        const input = box.querySelector('input[type="file"]');
        input.files = event.dataTransfer.files;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  function compactErrors(form) {
    form.querySelectorAll('div.jdgm-input-error').forEach(error => {
      if (error.querySelector('.rawry-review-error-copy')) return;
      const message = error.textContent.trim();
      if (!message) return;
      let summary = message;
      if (message === window.jdgmSettings?.widget_required_field_error_text || message === 'This field is required.') summary = 'Required';
      else if (message === window.jdgmSettings?.widget_email_field_error_text || message === 'Please enter a valid email address.') summary = 'Invalid email';
      else if (/^Please enter no more than \d+ characters\.?$/.test(message)) summary = 'Too long';
      const full = document.createElement('span');
      full.className = 'rawry-review-error-full';
      full.textContent = message;
      const visible = document.createElement('span');
      visible.className = 'rawry-review-error-copy';
      visible.setAttribute('aria-hidden', 'true');
      visible.textContent = summary;
      error.replaceChildren(full, visible);
      error.title = message;
    });
  }
  function arrangeReviews(root) {
    const header = root.querySelector('.jdgm-rev-widg__header');
    const row = header?.querySelector(':scope > .jdgm-row-carousel');
    const summary = header?.querySelector(':scope > .jdgm-row-stars');
    if (!row || !summary) return;
    for (const element of [summary, header.querySelector(':scope > .jdgm-form-wrapper')]) {
      if (element && (row.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING)) header.insertBefore(element, row);
    }
    const readMore = header.querySelector(':scope > .jdgm-row-readmore');
    const media = header.querySelector(':scope > .jdgm-row-media');
    if (readMore && media && (readMore.compareDocumentPosition(media) & Node.DOCUMENT_POSITION_PRECEDING)) readMore.after(media);
    const carousel = row.querySelector('.jdgm-rev-carousel');
    const glider = carousel?._glider;
    if (!glider || carousels.has(carousel)) return;
    carousels.add(carousel);
    glider.setOption({
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 1200, settings: { slidesToShow: 3 } }
      ]
    }, true);
    // Judge.me may initialize while hidden. Remeasure once actual width is available.
    const refresh = () => {
      if (carousel.clientWidth > 0 && carousel.clientWidth !== glider.containerWidth) glider.refresh();
    };
    const observer = new ResizeObserver(() => requestAnimationFrame(refresh));
    observer.observe(carousel);
    glider.refresh();
  }
  function scan() {
    document.querySelectorAll(selector).forEach(form => { enhance(form); compactErrors(form); });
    document.querySelectorAll('.our-reviewyyyy').forEach(arrangeReviews);
    installCloseReturn();
  }
  function scrollBelowHeader(element) {
    const headerBottom = [...document.querySelectorAll('#stickyATCrender, .site-header, .header-wrapper')]
      .map(element => element.getBoundingClientRect())
      .filter(rect => rect.height > 0 && rect.top >= -5 && rect.top < 100 && rect.bottom < innerHeight / 2)
      .reduce((bottom, rect) => Math.max(bottom, rect.bottom), 0);
    window.scrollTo({
      top: scrollY + element.getBoundingClientRect().top - Math.max(96, headerBottom) - 16,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  }
  function installCloseReturn() {
    const $ = window.jdgm?.$;
    if (!$) return;
    // Native lifecycle events are emitted on the first link in the popup group.
    document.querySelectorAll('.our-reviewyyyy .jdgm-rev__pic-link, .our-reviewyyyy .jdgm-rev__read-full, .our-reviewyyyy .jdgm-row-readmore a').forEach(link => {
      if (popupOrigins.has(link)) return;
      popupOrigins.add(link);
      const getHeading = () => {
        const popup = $.magnificPopup?.instance;
        const opener = popup?.st.el?.[0];
        if (!popup?.st.mainClass?.split(' ').includes('jdgm-rev-popup') || !opener?.matches('.jdgm-rev__read-full, .jdgm-row-readmore a')) return;
        return opener.closest('.our-reviewyyyy')?.querySelector('.jdgm-rev-widg__title');
      };
      $(link).on('jm-mfpBeforeOpen.rawryReviewReturn', () => {
        if (getHeading()) $.magnificPopup.instance.st.autoFocusLast = false;
      }).on('jm-mfpAfterClose.rawryReviewReturn', () => {
        const heading = getHeading();
        if (!heading) return;
        requestAnimationFrame(() => {
          if (!heading.isConnected || $.magnificPopup.instance.isOpen) return;
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
          scrollBelowHeader(heading);
        });
      });
    });
  }
  function installOpenHook() {
    const api = window.jdgm;
    if (!api?.openForm || api.openForm.rawryInlineForm) return;
    const nativeOpen = api.openForm;
    function openForm(widget) {
      const root = widget?.[0];
      const form = root?.matches('.our-reviewyyyy') && root.querySelector('.rawry-review-form');
      const wrapper = form && form.closest('.jdgm-form-wrapper');
      if (!wrapper) return nativeOpen.apply(this, arguments);
      // Native openForm slides, focuses an input, then scrolls. Use one scroll owner.
      api.closeQuestionForm?.(widget);
      api.$(wrapper).stop(true, true).show();
      api.toggleWriteReviewLink(widget, true);
      if (window.jdgmSettings?.widget_show_review_title_input === false) {
        form.querySelector('[name="review_title"]')?.closest('.jdgm-form__fieldset').style.setProperty('display', 'none');
      }
      const heading = form.querySelector('.jdgm-form__title');
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
      requestAnimationFrame(() => {
        if (!wrapper.getClientRects().length) return;
        scrollBelowHeader(form);
      });
    }
    openForm.rawryInlineForm = true;
    api.openForm = openForm;
  }
  function installCloseHook() {
    const api = window.jdgm;
    if (!api?.closeForm || api.closeForm.rawryInlineForm) return;
    const nativeClose = api.closeForm;
    function closeForm(widget) {
      const root = widget?.[0];
      const form = root?.matches('.our-reviewyyyy') && root.querySelector('.rawry-review-form');
      const wrapper = form && form.closest('.jdgm-form-wrapper');
      // Judge.me also calls closeForm before other forms open; only closing an open form moves the page.
      const wasOpen = Boolean(wrapper && wrapper.getClientRects().length);
      const result = nativeClose.apply(this, arguments);
      if (!wasOpen) return result;
      // Native closeForm slides up and leaves the page where it was, often past the reviews. Close at once and bring the
      // reviews' top back just under the sticky bars (David 2026-09-30).
      api.$(wrapper).stop(true, true);
      requestAnimationFrame(() => scrollBelowHeader(root.querySelector('.jdgm-rev-widg') || root));
      return result;
    }
    closeForm.rawryInlineForm = true;
    api.closeForm = closeForm;
  }
  function watchRoots() {
    document.querySelectorAll('.our-reviewyyyy').forEach(root => {
      if (observed.has(root)) return;
      observed.add(root);
      new MutationObserver(scan).observe(root, { childList: true, subtree: true });
    });
    scan();
    installOpenHook();
    installCloseHook();
  }
  watchRoots();
  // Widget content is injected asynchronously; section replacement is editor-only.
  document.addEventListener('DOMContentLoaded', watchRoots, { once: true });
  document.addEventListener('shopify:section:load', watchRoots);
  document.addEventListener('jdgm.doneSetupReviewForm', watchRoots);
})();
